module.exports = __webpack_public_path__ + "img/big-bottle-blue.acadcd3a.svg";